import { Grid, IconButton, Tooltip, Paper, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useCallback, useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack, MdClose } from 'react-icons/md'
import { GlobalContext } from '../../App'
import Programa from '../../components/Programa/Programa'
import Table from '../../components/Table'
import { metodoPrograma } from '../../components/api'
import { GiReceiveMoney, GiPayMoney, GiTakeMyMoney } from 'react-icons/gi'
import Edicao from './Edicao'
import dayjs from 'dayjs'
import Visualiza from './Visualiza'

const CaixaConsultorio = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [lista, setLista] = useState([])
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [entradas, setEntradas] = useState(0.0)
  const [saidas, setSaidas] = useState(0.0)
  const [resultado, setResultado] = useState(0.0)
  const [resultado15Dias, setResultado15Dias] = useState(0.0)
  const [dadosEdicao, setDadosEdicao] = useState(null)

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    height: 100,
    marginTop: 8,
    color: theme.palette.text.secondary,
  }))

  const getList = useCallback(() => {
    metodoPrograma('lista', { idLocalAtendimento: localAtendimento[0] }).then(
      (res) => {
        if (res.status) {
          if (res.valorEntrada) {
            setEntradas(res.valorEntrada)
          }
          if (res.valorSaida) {
            setSaidas(res.valorSaida)
          }
          if (res.totalGeral) {
            setResultado(res.totalGeral)
          }
          if (res.total15Dias) {
            setResultado15Dias(res.total15Dias)
          }
          setLista(res.lista)
        }
      },
    )
  }, [localAtendimento])

  const voltarCaixa = () => {
    setTela('visualiza')
    setDadosEdicao(null)
  }

  const voltar = useCallback(() => {
    setTela('lista')
    setDados(null)
    setDadosEdicao(null)
  }, [])

  const visualizaCaixa = () => {
    setTela('visualiza')
    getList()
  }

  const handleClick = (_, linha) => {
    setDados(linha)
    setTela('visualiza')
  }

  const abreNovoCaixa = useCallback(async () => {
    const res = await metodoPrograma('aberturaDeCaixa', {
      idLocalAtendimento: localAtendimento[0],
    })
    if (res.status) {
      getList()
    }
  }, [localAtendimento, getList])

  const fecharCaixa = async (e, item) => {
    e.stopPropagation()
    e.preventDefault()
    const res = await metodoPrograma('fechamentoDeCaixa', {
      idCaixa: item[0],
      idLocalAtendimento: localAtendimento[0],
    })
    if (res.status) {
      getList()
    }
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => abreNovoCaixa()}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'visualiza':
        setFerramentas(
          <>
            <Tooltip title="Adicionar">
              <IconButton
                onClick={() => {
                  setDados(null)
                  setTela('edicao')
                }}
              >
                <MdAdd />
              </IconButton>
            </Tooltip>
            <Tooltip title="Voltar">
              <IconButton onClick={voltar}>
                <MdArrowBack />
              </IconButton>
            </Tooltip>
          </>,
        )
        break
      case 'edicao':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltarCaixa}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela, voltar, abreNovoCaixa])

  useEffect(() => {
    if (localAtendimento) {
      getList()
    }
  }, [localAtendimento, getList])

  return (
    <Programa codigo="CtrlCaixaConsultorio" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3} md={3}>
              <Item
                style={{
                  backgroundColor: 'rgb(67 160 71 / 61%)',
                  padding: 20,
                }}
              >
                <Grid container spacing={2}>
                  <Grid xs={4}>
                    <Typography
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        textAlign: 'center',
                        padding: 12,
                      }}
                    >
                      <GiReceiveMoney
                        style={{
                          fontSize: 50,
                          color: 'white',
                        }}
                      />
                    </Typography>
                  </Grid>
                  <Grid
                    xs={8}
                    style={{
                      textAlign: 'right',
                      padding: 12,
                      color: 'white',
                    }}
                  >
                    Entradas
                    <br />
                    <Typography
                      style={{
                        fontWeight: 600,
                        textAlign: 'right',
                        fontSize: '1.5em',
                      }}
                    >
                      {entradas.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </Typography>
                  </Grid>
                </Grid>
              </Item>
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <Item
                style={{
                  backgroundColor: 'rgb(67 160 71 / 61%)',
                  padding: 20,
                }}
              >
                <Grid container spacing={2}>
                  <Grid xs={4}>
                    <Typography
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        textAlign: 'center',
                        padding: 12,
                      }}
                    >
                      <GiPayMoney
                        style={{
                          fontSize: 50,
                          color: 'white',
                        }}
                      />
                    </Typography>
                  </Grid>
                  <Grid
                    xs={8}
                    style={{
                      textAlign: 'right',
                      padding: 12,
                      color: 'white',
                    }}
                  >
                    Saídas
                    <br />
                    <Typography
                      style={{
                        fontWeight: 600,
                        textAlign: 'right',
                        fontSize: '1.5em',
                      }}
                    >
                      {saidas.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </Typography>
                  </Grid>
                </Grid>
              </Item>
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <Item
                style={{
                  backgroundColor: 'rgb(67 160 71 / 61%)',
                  padding: 20,
                }}
              >
                <Grid container spacing={2}>
                  <Grid xs={4}>
                    <Typography
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        textAlign: 'center',
                        padding: 12,
                      }}
                    >
                      <GiTakeMyMoney
                        style={{
                          fontSize: 50,
                          color: 'white',
                        }}
                      />
                    </Typography>
                  </Grid>
                  <Grid
                    xs={8}
                    style={{
                      textAlign: 'right',
                      padding: 12,
                      color: 'white',
                    }}
                  >
                    Últimos 15 dias
                    <br />
                    <Typography
                      style={{
                        fontWeight: 600,
                        textAlign: 'right',
                        fontSize: '1.5em',
                      }}
                    >
                      {resultado15Dias.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </Typography>
                  </Grid>
                </Grid>
              </Item>
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <Item
                style={{
                  backgroundColor: 'rgb(67 160 71 / 61%)',
                  padding: 20,
                }}
              >
                <Grid container spacing={2}>
                  <Grid xs={4}>
                    <Typography
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        textAlign: 'center',
                        padding: 12,
                      }}
                    >
                      <GiTakeMyMoney
                        style={{
                          fontSize: 50,
                          color: 'white',
                        }}
                      />
                    </Typography>
                  </Grid>
                  <Grid
                    xs={8}
                    style={{
                      textAlign: 'right',
                      padding: 12,
                      color: 'white',
                    }}
                  >
                    Resultado Geral
                    <br />
                    <Typography
                      style={{
                        fontWeight: 600,
                        textAlign: 'right',
                        fontSize: '1.5em',
                      }}
                    >
                      {resultado.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </Typography>
                  </Grid>
                </Grid>
              </Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Table
                dados={lista}
                head={['Abertura', 'Entradas', 'Saídas', 'Saldo', 'Status', '']}
                line={(item) => [
                  item[2] ? dayjs(item[2]).format('DD/MM/YYYY') : null,
                  item[3].toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }),
                  item[4].toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }),
                  item[5].toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }),
                  item[6],
                  item[6] === 'Aberto' && (
                    <IconButton
                      size="small"
                      title="Fechar Caixa"
                      key={item[0]}
                      onClick={(e) => fecharCaixa(e, item)}
                    >
                      <MdClose />
                    </IconButton>
                  ),
                ]}
                columnOptions={[]}
                onClick={handleClick}
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <div>
          {tela === 'visualiza' ? (
            <Visualiza {...{ dados, voltar, setDadosEdicao, setTela }} />
          ) : (
            <Edicao {...{ dados, voltarCaixa, visualizaCaixa, dadosEdicao }} />
          )}
        </div>
      )}
    </Programa>
  )
}

export default CaixaConsultorio
